import '@ts/pages/page-defaults';
const loginForm = document.getElementById('login-form');
const listener = (e) => {
    e.preventDefault();
    document.getElementById('submit-btn').disabled = true;
    document.getElementById('submit-btn').classList.add('processing');
    document.getElementById('remember').readOnly = true;
    document.getElementById('password').readOnly = true;
    document.getElementById('email').readOnly = true;
    // document.getElementById('submit-btn')?.querySelector('.animate-spin')?.classList.remove('hidden');
    if (loginForm === null) {
        console.error('login-form not found');
        return;
    }
    removeSubmitListener();
    loginForm.setAttribute('disabled', 'true');
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let timezoneInput = document.createElement('input');
    timezoneInput.setAttribute('type', 'hidden');
    timezoneInput.setAttribute('name', 'timezone');
    timezoneInput.setAttribute('value', timeZone);
    loginForm.appendChild(timezoneInput);
    grecaptcha.ready(() => {
        const recaptchaElm = document.getElementById('recaptcha');
        if (recaptchaElm === null) {
            console.error('recaptcha not found');
            return;
        }
        const sitekey = recaptchaElm.getAttribute('data-sitekey');
        if (sitekey === null) {
            console.error('sitekey not found');
            return;
        }
        grecaptcha.execute(sitekey, { action: 'login' }).then(function (token) {
            let input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', 'captcharesponse');
            input.setAttribute('value', token);
            loginForm.appendChild(input);
            loginForm.submit();
        });
    });
};
if (loginForm === null) {
    console.error('login-form not found');
}
else {
    loginForm.addEventListener('submit', listener);
}
function removeSubmitListener() {
    if (loginForm === null) {
        console.error('login-form not found');
        return;
    }
    loginForm.removeEventListener('submit', listener);
}
